<template>
    <div class="accountList">
        <bread-crumb :bread-list="breadList" />
        <div class="list-content">
            <div class="title-wrap">
                <i class="iconfont icon-tongyongbiaotiicon"></i>
                <span class="title-text">账户列表</span>
            </div>
            <div class="search-wrap">
                <div class="option-wrap">
                    <div class="option-item">
                        <span class="label">手机号</span>
                        <el-input size="small"
                                placeholder="请输入手机号"
                                  v-model="selectForm.telePhone"
                                  @blur="initData"
                                  :style="{width: '240px'}">
                        </el-input>
                    </div>
                </div>
                <div class="option-wrap">
                    <div class="option-item option-item-right">
                        <el-button
                            class="add_btn"
                            size="small"
                            @click="handleDetail('add')">新建</el-button>
                    </div>
                </div>
            </div>
            <div class="table-wrap">
                <el-table :data="dataList"
                          v-loading="loading"
                          stripe
                          style="width: 100%">
                    <el-table-column min-width="80px"
                                     label="序号">
                        <template slot-scope="scope">
                            <span>{{  scope.$index + 1 }}</span>
                        </template>
                    </el-table-column>
                    <el-table-column prop="accountNumber"
                                        width="120px"
                                     label="工号">
                    </el-table-column>
                    <el-table-column prop="accountName"
                                     min-width="100px"
                                     label="姓名">
                    </el-table-column>

                    <el-table-column min-width="100px"
                                     label="角色">
                        <template slot-scope="scope">
                            <span>
                                {{ scope.row.roles ? scope.row.roles[0].roleName : '-'}}
                            </span>
                        </template>
                    </el-table-column>
                    <el-table-column prop="phone"
                                     min-width="125px"
                                     label="手机号码">
                    </el-table-column>
                    <el-table-column min-width="140px"
                                     label="注册日期">
                        <template slot-scope="scope">
                            <span>
                                {{ scope.row.lastTime|formatDate }}
                            </span>
                        </template>
                    </el-table-column>
                    <el-table-column
                                     label="操作"
                                     width="160px">
                        <template slot-scope="scope">
                                <span @click="handleDetail('check', scope.row.iuid)"
                                      class="link-btn">查看</span>

                                <span @click="handleDetail('edit', scope.row.iuid)"
                                      class="link-btn">编辑</span>

                                <span @click="changePassword(scope.row)"
                                      class="link-btn">修改密码</span>
                        </template>
                    </el-table-column>
                    <div slot="empty">
                        <table-empty />
                    </div>
                </el-table>
            </div>
            <div class="pagination-wrap">
                <el-pagination background
                               @current-change="pageChange"
                               :current-page.sync="page.current"
                               :page-size="page.pageSize"
                               layout="total, prev, pager, next, jumper"
                               :total="page.total"></el-pagination>
            </div>
        </div>

        <el-dialog title="基本信息"
                   :visible.sync="showDetail"
                   :close-on-click-modal="false"
                   width="460px"
                   class="detail-dialog">
            <el-form :model="staffForm"
                     :rules="staffRules"
                     label-width="94px"
                     class="dialogform-wrap"
                     ref="staffForm"
                     v-if="editType !== 'check'">
                <el-form-item label="姓名"
                              prop="name">
                    <el-input v-model.trim="staffForm.name"
                              placeholder="请输入姓名"
                              :style="{width: '294px'}"
                              maxlength="15"
                              size="small"></el-input>
                </el-form-item>
                <el-form-item label="登录手机号"
                              prop="phone">
                    <el-input v-model.trim="staffForm.phone"
                              placeholder="请输入手机号"
                              :style="{width: '294px'}"
                              maxlength="11"
                              size="small"
                              :disabled="editType !== 'add'"></el-input>
                </el-form-item>
                <el-form-item label="角色"
                              prop="role">
                    <el-select v-model="staffForm.role"
                                   placeholder="请选择"
                                   size="small"
                                   :style="{width: '294px'}"
                                   >
                            <el-option
                                v-for="item in roleList"
                                :key="item.incId"
                                :label="item.roleName"
                                :value="item.roleId">
                            </el-option>
                        </el-select>
                </el-form-item>
                <el-form-item label="工号"
                              prop="number">
                    <el-input v-model.trim="staffForm.number"
                              placeholder="请输入工号"
                              :style="{width: '294px'}"
                              maxlength="11"
                              size="small"
                              :disabled="editType !== 'add'"></el-input>
                </el-form-item>
                <!-- <el-form-item label="登录密码"
                              prop="password"
                              :required="true"
                              >
                    <el-input v-model.trim="staffForm.password"
                              placeholder="请输入密码"
                              type="password"
                              :style="{width: '220px'}"
                              maxlength="32"
                              size="small"
                              :disabled="editType !== 'add'"></el-input>
                </el-form-item> -->
                <div class="changePassword"
                     v-if="editType === 'edit'"
                     @click="changePassword(accountDetail)">修改密码</div>
                <div class="dialog-btn-wrap">
                    <el-button size="small"
                               type="primary"
                               @click="saveForm('staffForm')">保 存</el-button>
                    <el-button size="small"
                               class="cancle-btn"
                               plain
                               @click="cancelForm()">取 消</el-button>
                </div>
            </el-form>
            <el-form :model="staffForm"
                     :rules="staffRules"
                     label-width="94px"
                     class="dialogform-wrap"
                     ref="staffForm"
                     v-else>
                <el-form-item label="姓名"
                              prop="name">
                    <el-input v-model.trim="staffForm.name"
                              placeholder="请输入姓名"
                              :style="{width: '294px'}"
                              maxlength="15"
                              size="small"
                              :disabled="true"></el-input>
                </el-form-item>
                <el-form-item label="登录手机号"
                              prop="phone">
                    <el-input v-model.trim="staffForm.phone"
                              placeholder="请输入手机号"
                              :style="{width: '294px'}"
                              maxlength="11"
                              size="small"
                              :disabled="true"></el-input>
                </el-form-item>
                <el-form-item label="角色"
                              prop="role">
                    <el-select v-model="staffForm.role"
                                   placeholder="请选择"
                                   size="small"
                                   :style="{width: '294px'}"
                                   disabled
                                   >
                            <el-option
                                v-for="item in roleList"
                                :key="item.incId"
                                :label="item.roleName"
                                :value="item.roleId">
                            </el-option>
                        </el-select>
                </el-form-item>
                <el-form-item label="工号"
                              prop="number">
                    <el-input v-model.trim="staffForm.number"
                              placeholder="请输入工号"
                              :style="{width: '294px'}"
                              maxlength="11"
                              size="small"
                              :disabled="true"></el-input>
                </el-form-item>
                <!-- <el-form-item label="登陆密码"
                              prop="password"
                              :required="true">
                    <el-input v-model.trim="staffForm.password"
                              type="password"
                              placeholder="请输入密码"
                              :style="{width: '220px'}"
                              maxlength="32"
                              size="small"
                              :disabled="true"></el-input>
                </el-form-item> -->
                <div class="dialog-btn-wrap">
                    <el-button size="small"
                               class="cancle-btn"
                               plain
                               @click="cancelForm()">取 消</el-button>
                </div>
            </el-form>
        </el-dialog>

        <el-dialog :visible.sync="passVisible"
                   top="20vh"
                   title="修改密码"
                   width="454px"
                   :close-on-click-modal="false"
                   class="pass-dialog">
            <el-form :model="passForm"
                     ref="passForm"
                     label-width="70px"
                     :rules="passRules"
                     class="pass-passForm"
                     v-loading="passFormLoading">
                <el-form-item label="手机号">
                    <el-input v-model="passForm.phone"
                              size="small"
                              disabled>
                    </el-input>
                </el-form-item>
                <el-form-item label="验证码"
                              prop="code"
                              :rules="[{ required: true, message: '请输入验证码', trigger: 'change'}, { required: true, message: '请输入验证码', trigger: 'blur'}]">
                    <el-input v-model="passForm.code"
                              placeholder="请输入验证码"
                              auto-complete="new-password"
                              size="small"
                              :style="{width: '294px'}">
                    </el-input>
                    <div class="get-code"
                         :class="[{'click-code': codeCanClick}]"
                         @click="getCode">{{codeStr}}</div>
                </el-form-item>
                <el-form-item label="新密码"
                              prop="newPassword"
                              style="width: 400px;">
                    <el-popover placement="right-start"
                                width="236px"
                                popper-class="userList-popover-hover-pass"
                                trigger="hover">
                        <div class="pass-length">
                            <i class="el-icon-circle-check"
                               v-if="passShow"></i>
                            <i class="el-icon-circle-close"
                               v-else></i>
                            <p class="pass-text">长度为8-32个字符</p>
                        </div>
                        <div class="pass-rule">
                            <i class="el-icon-circle-check"
                               v-if="ruleShow"></i>
                            <i class="el-icon-circle-close"
                               v-else></i>
                            <p class="pass-text">数字、大小写字母以及特殊字符至少包含两种</p>
                        </div>
                        <el-input v-model="passForm.newPassword"
                                  slot="reference"
                                  type="password"
                                  maxlength="50"
                                  auto-complete="new-password"
                                  :style="{width: '294px'}"
                                  size="small"
                                  placeholder="请输入新密码">
                        </el-input>
                    </el-popover>
                </el-form-item>
                <el-form-item style="padding-bottom: 20px;">
                    <el-button type="primary"
                               size="small"
                               class="commit-btn"
                               @click="handleCommitPass">确定</el-button>
                    <el-button class="cancle-btn"
                               size="small"
                               plain
                               @click="handleCancle">取消</el-button>
                </el-form-item>
            </el-form>
        </el-dialog>
    </div>
</template>

<script>
import { postAccountList, postAddAccount, getAccount, postSendVerification, putChangePassword, putPpdateAccount } from '@/api/patient/account'
export default {
    name: 'accountList',
    data () {
        var checkPassword = (rule, value, callback) => {
            if (value === '') {
                this.passShow = false
                this.ruleShow = false
                callback(new Error('请输入新密码！'))
            } else {
                if (value.length > 32 || value.length < 8) {
                    this.passShow = false
                    callback(new Error('密码格式错误!'))
                } else {
                    this.passShow = true
                    // 判断密码强弱
                    let modes = this.checkPasswordStrong(value)
                    if (modes < 2) {
                        this.ruleShow = false
                        callback(new Error('密码格式错误!'))
                    } else {
                        this.ruleShow = true
                        callback()
                    }
                }
            }
        }
        return {
            breadList: [{ label: '账户管理' }, { label: '账户列表' }],
            selectForm: {
                telePhone: ''
            },
            page: {
                current: 1,
                total: 1,
                pageSize: 10
            },
            dataList: [],
            loading: false,
            roleList: [],
            editType: 'add',
            showDetail: false,
            showPassWordBrn: true,
            passVisible: false,
            accountDetail: {},
            staffForm: {
                name: '',
                phone: '',
                role: 'c611c02d28bf42418b13e5c83799f287',
                // password: '',
                number: ''
            },
            staffRules: {
                name: [
                    { required: true, message: '请输入姓名', trigger: 'blur' },
                    { min: 2, max: 15, message: '长度在 2 到 15 个字符', trigger: 'blur' }
                ],
                phone: [
                    { required: true, message: '请输入手机号', trigger: 'blur' },
                    { min: 11, max: 11, message: '请输入正确手机号', trigger: 'blur' }
                ],
                number: [
                    { required: true, message: '请输入工号', trigger: 'blur' }
                ]
            },
            passFormLoading: false,
            passForm: {
                code: '',
                phone: '',
                iuid: '',
                newPassword: ''
            },
            codeCanClick: true,
            ruleShow: false,
            passShow: false,
            codeStr: '获取验证码',
            passRules: {
                newPassword: [{ required: true, validator: checkPassword, trigger: 'change' }]
            }
        }
    },
    created () {
        this.initData()
        this.getRole()
    },
    filters: {
        formatDate (value) {
            if (value) {
                return value.substring(0, 16)
            } else {
                return ''
            }
        }
    },
    methods: {
        // 判断密码强弱
        checkPasswordStrong (password) {
            let modes = 0
            if (/\d/.test(password)) { // 数字
                modes++
            }
            if (/[a-z]/.test(password) || /[A-Z]/.test(password)) { // 大小写
                modes++
            }
            if (/\W/.test(password)) { // 特殊字符
                modes++
            }
            return modes
        },
        handleDetail (type, iuid) {
            this.editType = type
            if (this.$refs.staffForm) {
                this.$refs.staffForm.resetFields()
            }
            if (type === 'add') {
                this.staffForm = {
                    name: '',
                    phone: '',
                    role: '',
                    // password: '',
                    number: ''
                }
            } else {
                this.getAccountDetail(iuid)
            }
            this.showDetail = true
        },
        async getAccountDetail (iuid) {
            const { state, results } = await getAccount(iuid)
            if (state === 200 && results) {
                this.staffForm = {
                    iuid: iuid,
                    name: results.accountName,
                    phone: results.phone,
                    role: results.roles ? results.roles[0].roleId : '暂无',
                    // password: '.........',
                    number: results.accountNumber
                }

                this.accountDetail = results
            }
        },
        pageChange (value) {
            this.page.current = value
            this.getList()
        },
        saveForm (formName) {
            this.$refs[formName].validate((valid) => {
                if (valid && this.editType === 'add') {
                    this.addCount()
                } else if (valid && this.editType === 'edit') {
                    this.updateAccount()
                } else {
                    console.log('error submit!!')
                    return false
                }
            })
        },
        cancelForm () {
            this.showDetail = false
        },
        initData () {
            this.page.current = 1
            this.getList()
        },
        async getList () {
            this.loading = true
            const param = {
                current: this.page.current,
                size: this.page.pageSize,
                phone: this.selectForm.telePhone
            }
            const { results, total } = await postAccountList(param)
            this.loading = false
            this.dataList = results
            this.page.total = total
        },
        async addCount () {
            const param = {
                // 姓名
                accountName: this.staffForm.name,
                // 工号
                accountNumber: this.staffForm.number,
                // 手机号
                phone: this.staffForm.phone,
                //  密码
                // password: this.staffForm.password,
                // 角色
                roleIds: [this.staffForm.role]
            }
            this.loading = true
            const { state, subMsg } = await postAddAccount(param)
            this.loading = false
            if (state && state === 200) {
                this.showDetail = false
                this.$message({
                    message: '新建成功',
                    type: 'success'
                })

                this.initData()
            } else {
                if (subMsg && subMsg) {
                    this.$message.error(subMsg)
                } else {
                    this.$message.error('添加失败')
                }
            }
        },
        async updateAccount () {
            this.loading = true
            const param = {
                iuid: this.staffForm.iuid,
                // 姓名
                accountName: this.staffForm.name,
                // 工号
                accountNumber: this.staffForm.number,
                // 手机号
                phone: this.staffForm.phone,
                // 角色
                roleIds: [this.staffForm.role]
            }
            const { results, state } = await putPpdateAccount(param)
            this.loading = false
            if (state === 200 && results) {
                this.$message({
                    message: '编辑成功',
                    type: 'success'
                })
                this.showDetail = false
                this.initData()
            } else {
                this.$message.error('编辑失败')
            }
        },
        async getRole () {
            const { results } = await this.$services.hospital.getRoleList()
            this.roleList = results
        },
        changePass (formName) {
            console.log('changePass')
        },
        // 点击修改密码
        changePassword (detail) {
            this.showDetail = false
            this.passShow = false
            this.ruleShow = false
            this.passForm.phone = detail.phone
            this.passForm.iuid = detail.iuid
            this.passForm.newPassword = ''
            this.passForm.code = ''
            this.passVisible = true
            if (this.$refs.passForm) {
                this.$refs.passForm.resetFields()
            }
        },
        handleCancle () {
            this.passVisible = false
            clearInterval(this.timerInterval)
            this.codeCanClick = true
            this.codeStr = '获取验证码'
        },
        // 确定修改密码
        handleCommitPass () {
            this.$refs.passForm.validate((valid) => {
                if (valid) {
                    this.handleSavePass()
                } else {
                    return false
                }
            })
        },
        async handleSavePass () {
            const params = {
                code: this.passForm.code,
                iuid: this.passForm.iuid,
                newPassword: this.passForm.newPassword
            }
            this.passFormLoading = true
            const { results } = await putChangePassword(params)
            if (results === 'OK') {
                this.passVisible = false
                this.$message({
                    message: '成功修改密码！',
                    customClass: 'hos-message--success',
                    iconClass: 'el-icon-success',
                    duration: '2000'
                })
                this.initData()
            } else {
                this.$message.error('修改密码失败')
            }
            this.passFormLoading = false
        },
        getCode () {
            if (!this.codeCanClick) {
                return
            }
            const phoneTest = /^[1][3,4,5,7,8,9][0-9]{9}$/
            if (!this.passForm.phone || !phoneTest.test(this.passForm.phone)) {
                return
            }
            let timer = 60
            this.codeStr = timer + 's'
            this.codeCanClick = false
            this.timerInterval = setInterval(() => {
                timer--
                if (timer < 1) {
                    clearInterval(this.timerInterval)
                    this.codeCanClick = true
                    this.codeStr = '获取验证码'
                } else {
                    this.codeStr = timer + 's'
                }
            }, 1000)
            this.handleVerification()
        },
        async handleVerification () {
            const params = {
                phone: this.passForm.phone,
                signName: '树兰医疗'
            }
            await postSendVerification(params)
        }
    }
}
</script>
<style lang="scss">
.userList-popover-hover-pass {
    box-shadow: 0 0 4px 0 rgba(0, 0, 0, 0.2);
    border-radius: 3px;
    .pass-length {
        display: flex;
        align-items: center;
        height: 20px;
        .el-icon-circle-check {
            color: #4acfb1;
            font-size: 12px;
            margin-right: 5px;
        }
        .el-icon-circle-close {
            color: #ec6a69;
            margin-right: 5px;
            font-size: 12px;
        }
        .pass-text {
            font-family: PingFangSC-Regular;
            font-size: 12px;
            color: #333333;
            width: 220px;
        }
    }
    .pass-rule {
        display: flex;
        align-items: flex-start;
        height: 20px;
        padding-bottom: 14px;
        .el-icon-circle-check {
            color: #4acfb1;
            font-size: 12px;
            margin-right: 5px;
            margin-top: 3px;
        }
        .el-icon-circle-close {
            color: #ec6a69;
            margin-right: 5px;
            font-size: 12px;
            margin-top: 3px;
        }
        .pass-text {
            font-family: PingFangSC-Regular;
            font-size: 12px;
            color: #333333;
            width: 220px;
            line-height: 18px;
        }
    }
}
.accountList{
    .el-table .cell{
        padding-left: 20px !important;
    }
    .pass-dialog {
        .el-dialog__body {
            .pass-passForm {
                .el-form-item__label {
                    font-family: PingFangSC-Regular;
                    font-size: 14px;
                    color: #666666;
                    letter-spacing: 0;
                }
                .el-input {
                    .el-input__inner {
                        background: #ffffff;
                        border: 1px solid #dcdcdc;
                        border-radius: 3px;
                        width: 330px;
                        height: 32px;
                        padding: 5px 10px;
                    }
                }
                .commit-btn {
                    width: 100px;
                    height: 32px;
                    font-family: PingFang-SC-Regular;
                    font-size: 14px;
                    color: #ffffff;
                    letter-spacing: 4px;
                    padding: 0;
                }
                .cancle-btn {
                    width: 100px;
                    height: 32px;
                    font-family: PingFang-SC-Regular;
                    font-size: 14px;
                    color: #666;
                    letter-spacing: 4px;
                    padding: 0;
                    border: 1px solid #dbdbdb;
                }
                .cancle-btn:hover {
                    background-color: $table-head;
                }
            }

            .get-code {
                position: absolute;
                top: 1px;
                right: 15px;
                height: 30px;
                line-height: 30px;
                width: 100px;
                text-align: center;
                border-left: 1px solid #dcdcdc;
                background: #f6f6f6;
                color: #999999;
                font-size: 14px;
                cursor: not-allowed;
                border-radius: 3px;
            }
            .click-code {
                background: #fff;
                color: #666;
                cursor: pointer;
            }
            .el-input__suffix {
                .el-input__icon {
                    line-height: 32px;
                }
            }
        }
    }
    .detail-dialog {
        .dialog-btn-wrap {
            button {
                font-size: 14px;
            }
            .cancle-btn {
                color: #666666;
                border: 1px solid #dbdbdb;
            }
            .cancle-btn:hover {
                background-color: $table-head;
            }
        }
    }
}
</style>
<style lang="scss" scoped>
.accountList{
    height: 100%;
    .list-content {
        height: calc(100% - 81px);
        box-shadow: 0 1px 4px 0 rgba(202, 202, 202, 0.5);
        margin: 20px;
        padding: 20px 20px 0 20px;
        background: #fff;
        overflow: auto;

        .title-wrap {
            font-size: 0;
            height: 16px;
            line-height: 16px;
            padding-bottom: 10px;
            border-bottom: 1px solid #ccc;
            .icon-tongyongbiaotiicon {
                color: $color-primary;
                font-size: 16px;
                vertical-align: middle;
            }
            .title-text {
                font-size: 14px;
                color: #333333;
                margin-left: 10px;
                display: inline-block;
                height: 16px;
                line-height: 16px;
                vertical-align: middle;
            }
        }

        .search-wrap {
            display: flex;
            justify-content: space-between;
            align-items: center;
            .option-wrap {
                display: flex;
                flex-wrap: wrap;
                &:last-child {
                    margin-bottom: 0;
                }
                .option-item {
                    margin: 20px 20px 20px 0;
                    .label {
                        padding-right: 10px;
                        font-size: 14px;
                        color: #666;
                    }
                    &:last-child {
                        margin-right: 0;
                    }
                    .el-select {
                        margin-right: 10px;
                        &:last-child {
                            margin-right: 0;
                        }
                    }
                    .el-input {
                        margin-right: 10px;
                        .el-input__inner {
                            height: 32px;
                        }
                    }
                    .el-date-editor {
                        margin-right: 10px;
                    }
                }
                .select-btn-wrap {
                    font-size: 0;
                    margin-top: 20px;
                    .el-button--small {
                        width: 80px;
                        padding: 8px 15px;
                        font-size: 14px;
                    }
                    .el-button--info.is-plain {
                        background: #f5f5f5;
                        border-color: #cccccc;
                        color: #666;
                    }
                }
            }
        }
    }

    .add_btn{
        padding: 9px 15px;
        font-family: PingFangSC-Regular;
        font-size: 14px;
        color: #06AEA6;
        text-align: center;
        line-height: 14px;
        border: 1px solid #06AEA6;
        border-radius: 3px;
    }

    .dialogform-wrap{
        padding-bottom: 20px;
    }

    .dialog-btn-wrap{
        padding-left: 94px;
    }

    .detail-dialog{
        .el-button{
            width: 96px;
        }
    }

    .changePassword{
        position: absolute;
        right: 50px;
        font-size: 14px;
        color: #3FB1FA;
        cursor: pointer;
    }

    .link-btn {
        cursor: pointer;
        color: $a-link;
        font-size: 12px;
        display: inline-block;
        height: 14px;
        line-height: 14px;
        border-right: 1px solid $a-link;
        margin-right: 6px;
        padding-right: 6px;
        &:last-child {
            border-right: none;
            margin-right: 0;
            padding-right: 0;
        }
    }

    .get-code {
        position: absolute;
        top: 1px;
        right: 37px;
        height: 30px;
        line-height: 30px;
        width: 100px;
        text-align: center;
        border-left: 1px solid #dcdcdc;
        background: #f6f6f6;
        color: #999999;
        font-size: 14px;
        cursor: not-allowed;
        border-radius: 3px;
    }
    .click-code {
        background: #fff;
        color: #666;
        cursor: pointer;
    }
    .commit-btn, .cancle-btn{
        width: 96px;
    }
}
</style>
